
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: { 
                "carNo":"",
                "positionNo":"",
                "longitude":"",
                "latitude":""

            },
            responseCode:{

            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台路边车辆自助登记",
                t_url: this.commonUrls.test+"roadsideCarCheckIn",
                p_url: this.commonUrls.prod+"roadsideCarCheckIn",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号码' },
                        { info1: 'positionNo', info2: '否', info3: 'String', info4: '车位号' },
                        { info1: 'longitude', info2: '否', info3: 'double', info4: '经度' },
                        { info1: 'latitude', info2: '否', info3: 'double', info4: '维度' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'failReason', info2: '否', info3: 'String', info4: '失败原因' },
                        { info1: 'success', info2: '是', info3: 'Boolean', info4: '是否成功(false,success)' },

                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/roadsideCarCheckIn.vue